import React from 'react';
import { LinkOptionSystemStyle } from './style';

export default function LinkOptionSystem({ systemName, border, href, width, bgColor }) {
  return (
    <LinkOptionSystemStyle href={href} target="_blank" rel="noreferrer" width={width} border={border} bgColor={bgColor}>
      {systemName}
    </LinkOptionSystemStyle>
  );
}
